import { Nav } from "reactstrap";
import styled from "styled-components";

const HeaderNav = styled(Nav)`
  margin-left: auto;
  gap: 12px;
  @media (min-width: 992px) {
    gap: 24px;
  }
`;

export default HeaderNav;
